module.exports = __webpack_public_path__ + "static/media/map.295e3353.jpg";